/**
 * Template gallery client per ED-A12 §D1. Listing only — the portal's
 * new-template panel needs cards + categories; template_body never
 * crosses the wire here (the clone happens server-side via
 * POST /v1/templates {from_gallery_id}).
 */
import { apiClient } from "./apiClient";

export interface GalleryItemSummary {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  category: { industry: string; use_case: string };
  tags: string[];
  metadata: {
    thumbnail_url: string | null;
    block_count: number;
    [k: string]: unknown;
  };
  pricing: { tier: string; requires_subscription: boolean };
  stats: { use_count: number; [k: string]: unknown };
}

export interface GalleryListParams {
  industry?: string;
  use_case?: string;
  q?: string;
  limit?: number;
}

interface GalleryListResponse {
  data: GalleryItemSummary[];
  pagination: { limit: number; next_cursor: string | null; has_more: boolean };
}

export async function listGallery(
  params: GalleryListParams = {},
): Promise<GalleryListResponse> {
  const search = new URLSearchParams();
  if (params.industry !== undefined) search.set("industry", params.industry);
  if (params.use_case !== undefined) search.set("use_case", params.use_case);
  if (params.q !== undefined && params.q !== "") search.set("q", params.q);
  if (params.limit !== undefined) search.set("limit", String(params.limit));
  const query = search.toString();
  const path = query === "" ? "/v1/template-gallery" : `/v1/template-gallery?${query}`;
  return apiClient.get<GalleryListResponse>(path);
}

export interface GalleryPreview {
  html: string;
  warnings: Array<{ severity?: string; message?: string; [k: string]: unknown }>;
}

/** Compiled-HTML preview for the §C2 modal. */
export async function previewGalleryItem(id: string): Promise<GalleryPreview> {
  const res = await apiClient.post<{ data: GalleryPreview }>(
    `/v1/template-gallery/${id}/preview`,
  );
  return res.data;
}
